import { useApi } from './use-api'
import { useAuthApi } from './use-auth-api'

export const api = {
  ...useApi(),
  auth: useAuthApi()
}
